import { createConsumer } from '@rails/actioncable'
import { detect } from 'detect-browser'

cable = null

export connect = (channel, subscriber) ->
  cable = createCable()

  return unless cable?

  cable.subscriptions.create(channel, {
    connected: () ->
      subscriber({ msg: 'Connected', data: null })
    disconnected: () ->
      subscriber({ msg: 'Disconnected', data: null })
    received: (data) ->
      subscriber({ msg: 'Received', data: data })
    rejected: () ->
      subscriber({ msg: 'Rejected', data: null })
  })


createCable = () ->
  browser = detect()

  # Too many issues with ie supporting / not supporting sockets
  return if browser && browser.name == 'ie'

  socketUrl = "wss://#{location.host}/cable"
  supportsSockets = window.WebSocket?

  if !cable && supportsSockets
    cable = createConsumer(socketUrl)

    # Before we navigate / reload disconnect the cable
    # This is so we don't have many cable connections as time goes on
    window.onbeforeunload = () ->
      return unless cable?

      cable.disconnect()
      cable.subscriptions.subscriptions.forEach (sub) ->
        cable.subscriptions.remove(sub)


  return cable
